module.exports = __webpack_public_path__ + "static/media/chemvr.7b6e8e60.jpg";